@if ( original !== undefined) {
  <div class="lm-lpl-editor-toolbar toolbar editor-toolbar formatter-toolbar">
    <div class="buttonset">
      <button
            soho-button="icon"
            icon="left-arrow"
            class="btn-editor"
            soho-tooltip
            [content] = "Soho.Locale.translate('LPL_EDITOR_PREVIOUS_DIFFERENCE')"
            (click)="onMonacoClickEvent('previous')"
      ></button>
      <button
            soho-button="icon"
            icon="right-arrow"
            class="btn-editor"
            soho-tooltip
            [content] = "Soho.Locale.translate('LPL_EDITOR_NEXT_DIFFERENCE')"
            (click)="onMonacoClickEvent('next')"
      ></button>
      <button
        soho-button="icon"
        icon="search"
        class="btn-editor"
        (click)="onMonacoClickEvent('actions.find')"
      ></button>
    </div>
    <div class="showWhiteSpaceChanges">
        <input
            type="checkbox"
            soho-checkbox
            [attr.id]="'lm-ignoreTrimWhitespace-'+ uniqueId + '-checkbox'"
            [readOnly]="false"
            [disabled]="false"
            [ngModel]="showWhiteSpaceChanges"
            (ngModelChange)="handleShowWhiteSpaceChanges($event)">
        <label
            class='lm-checkbox-label'
            soho-label
            [attr.for]="'lm-ignoreTrimWhitespace-'+ uniqueId + '-checkbox'"
            [forCheckBox]=true>{{ 'LPL_EDITOR_SHOW_WHITE_SPACE_CHANGES' | translate }}</label>
    </div>
  </div>
  <div class="editor-container lm-lpl-editor-diff" #editorContainer soho-alert></div>
}

